/**
 * Admin Configuration
 * (PIN verification moved to secure Edge Function)
 */
export const ADMIN_CONFIG = {
  pinLength: 6,
};
